export var MediaQuality;
(function (MediaQuality) {
    MediaQuality["ORIGINAL"] = "original";
    MediaQuality["P1080"] = "1080p";
    MediaQuality["P2160"] = "2160p";
    MediaQuality["Poster"] = "poster";
    MediaQuality["Preview"] = "preview";
    MediaQuality["Thumb"] = "thumb";
})(MediaQuality || (MediaQuality = {}));
//# sourceMappingURL=MediaQuality.js.map